
import { createContext } from 'react'

interface ILoadingActionContext {
    setLoading: (key: string) => void;
    setComplete: (key: string) => void;
    setValidating: (key: string) => void;
    setValid: (key: string) => void;
}

export const LoadingActionContext = createContext<ILoadingActionContext>({
    setComplete: () => {},
    setLoading: () => {},
    setValidating: () => {},
    setValid: () => {}
});

export default LoadingActionContext;